<template>
  <header
    v-if="currentPage && !currentPage.acf.skjul_sidetopp"
    :class="[bgType]"
    class="top-page-header padding_large"
  >
    <headerContent
      v-if="currentPage"
      :textColor="theme.text"
      class="content"
      :backColor="theme.backText"
    >
      <div
        v-if="backPage.url && !currentPage.acf.heder_logo"
        v-observe-visibility="visibilityChanged"
        :class="[baseAnimation]"
        class="back-link"
      >
        <WpLink :url="backPage.url" :title="backPage.title">
          <StyledIcon class="icon" v-html="svgIcons.arrow2" />
          <span class="text">{{ backPage.title }}</span>
        </WpLink>
      </div>

      <WpImage
        v-if="currentPage && currentPage.acf && currentPage.acf.heder_logo"
        :data="currentPage.acf.heder_logo"
        class="logo-image"
        v-observe-visibility="visibilityChanged"
        :class="[baseAnimation]"
      />

      <ModuleHeading
        :level="1"
        v-observe-visibility="visibilityChanged"
        class="animate-delay-01"
        :class="[baseAnimation]"
      >
        <template v-if="!currentPage.acf.heder_logo">
          {{ currentPage.title.rendered }}
        </template>

        <template
          v-else-if="
            currentPage.acf.heder_logo && currentPage.acf.custom_page_title
          "
        >
          {{ currentPage.acf.custom_page_title }}
        </template>
      </ModuleHeading>

      <DynamicHtml
        class="excerpt animate-delay-02"
        v-if="currentPage.excerpt && currentPage.excerpt.rendered"
        v-observe-visibility="visibilityChanged"
        :class="[baseAnimation]"
      >
        {{ currentPage.excerpt.rendered }}
      </DynamicHtml>
      <LinksLine
        v-if="currentPage && currentPage.acf && currentPage.acf.links_header"
        v-observe-visibility="visibilityChanged"
        class="animate-delay-03"
        :class="[baseAnimation]"
        :data="currentPage.acf.links_header"
      />
    </headerContent>
    <WpImage
      v-if="bgType === 'bg-image'"
      :data="currentPage.acf.background_image"
      size="extra_large"
      background
      class="wide-image"
      placeholder
      lazy
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
    />
  </header>
</template>

<script>
import LinksLine from "@/components/blocks/LinksLine";
import styled from "vue-styled-components";
import WpImage from "@/components/elements/WpImage";
import WpLink from "@/components/elements/WpLink";
//import PageLogo from "@/components/blocks/PageLogo";
import StyledIcon from "@/components/elements/StyledIcon";

import { mapGetters } from "vuex";

const wrapperProps = { textColor: String, backColor: String };
const headerContent = styled("section", wrapperProps)`
  ${props =>
    props.textColor && props.textColor !== ""
      ? "color:" + props.textColor + ";"
      : ""};
  ${props =>
    props.backColor && props.backColor !== ""
      ? ".back-link { color:" + props.backColor + "}"
      : ""};
  ${props =>
    props.backColor && props.backColor !== ""
      ? ".back-link svg g{ fill: " + props.backColor + "}"
      : ""};
  ${props =>
    props.textColor && props.textColor !== ""
      ? ".links-line svg g{ fill: " + props.textColor + "}"
      : ""};
  a {
    &:hover {
      ~ .icon svg g {
        fill: ${props => props.backColor} !important;
      }
    }
  }
  .back-link {
    a {
      &:hover {
        color: ${props => props.textColor} !important;
        .icon svg g {
          fill: ${props => props.textColor} !important;
        }
      }
    }
  }
`;

export default {
  name: "page-header",
  components: {
    LinksLine,
    headerContent,
    WpImage,
    //PageLogo,
    WpLink,
    StyledIcon
  },
  mounted() {},
  computed: {
    ...mapGetters(["getPageById"]),
    typeLogo() {
      let type = "dark";
      if (this.currentPage && this.currentPage.acf.text_color) {
        type = this.currentPage.acf.text_color;
      }
      return type;
    },
    backPage() {
      let page = {
        url: null,
        title: null
      };
      const postType = this.currentPage.post_type;
      let item = null;
      let postId = null;

      if (postType === "page") postId = this.currentPage.post_parent;
      else if (postType === "aktiviteter"){
        postId = this.currentPage.post_parent || WPVUE.options.archives.aktiviteter_page;
      } 
      else {
        switch (postType) {
          case "events":
            postId = WPVUE.options.archives.events_archives;
            break;
          case "help":
            postId = WPVUE.options.archives.help_archives;
            break;
          case "sponsors":
            postId = WPVUE.options.archives.sponsors_page;
            break;
          case "post":
            postId = Number(WPVUE.post_page);
            break;
          case "inspirasjon":
            postId = Number(WPVUE.options.archives.inspirasjon_page);
            break;
        }
      }

      if (postId === 0 && this.currentPage.id !== Number(WPVUE.front_page)) {
        page.url = WPVUE.home_url + "/";
        page.title = "Forsiden";
      } else if (postId) {
        item = this.getPageById(postId);
        if (item) {
          page.url = item.link;
          page.title = item.title.rendered;
        }
      }

      return page;
    },
    bgType() {
      let bg = "bg-white";
      if (this.currentPage && this.currentPage.acf.bg_type) {
        switch (this.currentPage.acf.bg_type) {
          case "white":
            bg = "bg-white";
            break;
          case "gray":
            bg = "bg-gray";
            break;
          case "bg":
            bg = "bg-image";
            break;
        }
      }

      return bg;
    },
    theme() {
      let text = "";
      let backText = "";
      if (this.currentPage) {
        if (this.bgType === "bg-image") {
          if (this.currentPage.acf.text_color === "white") text = "#fff";
        }
        if (this.currentTheme(this.currentPage.id)) {
          backText = this.currentTheme(this.currentPage.id).select_color;
        }
      }
      return {
        text: text,
        backText: backText
      };
    }
  }
};
</script>
<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.top-page-header {
  @include mquery(600px) {
    .content {
      color: $fontColor !important;
      svg g {
        fill: $fontColor;
      }
    }
  }
  .back-link {
    position: relative;
    margin-bottom: 10px;
    a {
      &:hover {
        color: $fontColor;
        .icon svg g {
          fill: $fontColor;
        }
      }
    }
    .icon {
      margin-right: 10px;
      position: relative;
      top: 2px;
      svg {
        transform: rotate(180deg);
        g {
          transition: fill 0.1s ease-in-out;
        }
      }
    }
    a {
      color: inherit;
      text-decoration: none;
      font-size: 16px;
      font-weight: 700;
      transition: color 0.1s ease-in-out;
    }
  }
}
</style>
